module.exports = __webpack_public_path__ + "static/media/cq_allega_documento.97c50a41.svg";